// Adapted from https://github.com/vercel/next.js/blob/canary/examples/with-magic/lib/hooks.js
import useSWR from 'swr';

const fetcher = (url: string) =>
  fetch(url)
    .then((r) => r.json())
    .then((data) => {
      return { user: data?.user || null }
    });

type AuthUser = {
  issuer: string;
  publicAddress: string;
  email: string;
  createdAt: number;
  maxAge: number;
}

export function useAuth() {
  const { data, error, mutate } = useSWR('/api/auth/user', fetcher);
  const user: AuthUser | null = data?.user;

  return {
    auth: error ? null : user,
    hasFetched: data !== undefined, // brand new page loads start with data undefined
    refresh: () => mutate(), // refreshes the data with no mutation params
  };
}